import { useRef } from 'react';

import { Box, Icon, Menu, MenuButton, MenuItem, MenuList, Stack, Text, useColorModeValue } from '@ecoinvent/ui';
import { BiCheck, BiChevronDown } from 'react-icons/bi';

import StepHeader from '../components/StepHeader';
import { INDUSTRY_OPTIONS } from '../constants';

interface IndustryStepProps {
  value: string | null;
  onChange: (value: string) => void;
}

const IndustryStep = ({ value, onChange }: IndustryStepProps) => {
  const helperColor = useColorModeValue('gray.500', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const hoverBorderColor = useColorModeValue('gray.300', 'gray.500');
  const placeholderColor = useColorModeValue('gray.400', 'gray.500');
  const hoverBg = useColorModeValue('gray.50', 'gray.600');
  const iconColor = useColorModeValue('gray.500', 'gray.400');
  const menuBtnRef = useRef<HTMLButtonElement>(null);

  return (
    <Stack spacing={8} align="center" w="100%">
      <StepHeader step={3} totalSteps={3} title="What industry best describes your work?" />
      <Stack spacing={1} w="100%" maxW="400px">
        <Menu matchWidth>
          <MenuButton
            ref={menuBtnRef}
            as={Box}
            px={4}
            py={3}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="md"
            cursor="pointer"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            _hover={{ borderColor: hoverBorderColor }}
          >
            <Box display="flex" alignItems="center" justifyContent="space-between" w="100%">
              <Text color={value ? undefined : placeholderColor} fontSize="md" isTruncated>
                {value || 'Select your industry'}
              </Text>
              <Icon as={BiChevronDown} boxSize={5} color={iconColor} flexShrink={0} ml={2} />
            </Box>
          </MenuButton>
          <MenuList maxH="300px" overflowY="auto" zIndex="popover">
            {INDUSTRY_OPTIONS.map((industry) => (
              <MenuItem
                key={industry}
                onClick={() => onChange(industry)}
                icon={value === industry ? <Icon as={BiCheck} boxSize={4} /> : undefined}
                pl={value === industry ? undefined : 10}
                bg={value === industry ? hoverBg : undefined}
                fontSize="sm"
              >
                {industry}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Text fontSize="sm" color={helperColor}>
          Choose the closest match
        </Text>
      </Stack>
    </Stack>
  );
};

export default IndustryStep;
